import { render, staticRenderFns } from "./points-card.vue?vue&type=template&id=5dd71dd0&lang=pug&"
import script from "./points-card.vue?vue&type=script&lang=js&"
export * from "./points-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports